module.exports = __webpack_public_path__ + "static/media/Hoist_ios_6.7652be84.jpg";